import {
  makeStyles,
  Skeleton,
  SkeletonItem,
  tokens,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useClasses = makeStyles({
  skeletonRow: {
    marginBottom: tokens.spacingVerticalM,
  },
});

export const QueryFilterTagsSkeleton = () => {
  const classes = useClasses();
  const { t } = useTranslation();

  return (
    <Skeleton aria-label={t("loading")}>
      <SkeletonItem className={classes.skeletonRow} size={20} />
    </Skeleton>
  );
};
